import SmartCheckInFeedbackSettings from './CheckInFeedbackSettings';

export default SmartCheckInFeedbackSettings;
